// @flow

import type { Node } from 'react';
import styled, { css } from 'styled-components';
import { connect } from 'react-redux';
import type { Theme } from '../../../../../types';
import { getUiSetting } from '../../../../../store/uiStore';

type OwnProps = {|
  galleryId: number,
  slideId: string,
  selectedSlideId: string,
  children: Node,
|};

type StateProps = {|
  selectedUiSlideId: string | boolean,
|};

type Props = {|
  ...OwnProps,
  ...StateProps,
|};

const isSelected = ({ selectedSlideId, selectedUiSlideId, slideId }: Props) => (typeof selectedUiSlideId === 'string' ? selectedUiSlideId === slideId : selectedSlideId === slideId);

const GallerySlide = styled<any, Theme>('div')`
  box-sizing: border-box;
  height: 4.75rem;
  display: flex;
  align-items: center;
  justify-content: center;
  outline: solid 0.9px ${props => props.theme.gallery.image.borderColor};
  ${props => isSelected(props) && css`
    outline: solid 0.9px ${props.theme.gallery.image.selectedColor};
  `}
  margin: 0.375em;
  overflow: hidden;

  > img {
    max-height: 4.5rem;
  }
`;

const mapStateToProps = (state: any, { galleryId }: OwnProps): StateProps => ({
  selectedUiSlideId: getUiSetting(state, `selectedSlide-${galleryId}`),
});

export default connect<any, OwnProps, StateProps, any, any, any>(mapStateToProps)(GallerySlide);
